<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import CenteredContentLogoSection from '@/components/SponsorshipTemplates/components/CenteredContentLogoSection.vue'
import InfoImageCenterSection from '@/components/SponsorshipTemplates/components/InfoImageCenterSection.vue'
import InfoImageColSection from '@/components/SponsorshipTemplates/components/InfoImageColSection.vue'
import HeroSection from '@/components/SponsorshipTemplates/SponsorshipHeading.vue'
import {
  fetchSponsorshipStore,
  useSponsorshipData,
  useSponsorshipSeo
} from '@/services/sponsorshipService'

useSponsorshipSeo()

const data = ref()
const route = useRoute()

onMounted(async () => {
  await fetchSponsorshipStore(route.params.slug as string)
  data.value = useSponsorshipData().value
})
</script>
<template>
  <HeroSection
    :title="data?.sponsorship_hero?.title"
    :subTitle="data?.sponsorship_hero?.description"
    :logo="data?.sponsorship_hero?.sponsorlogo"
    :backgroundLogo="data?.sponsorship_hero?.backgroundimage"
  ></HeroSection>
  <InfoImageColSection
    :title="data?.info_image_section?.title"
    :description="data?.info_image_section?.description"
    :image="data?.info_image_section?.image"
  ></InfoImageColSection>
  <CenteredContentLogoSection
    :title="data?.image_logo_ad_section?.subtitle"
    :content="data?.image_logo_ad_section?.title"
    :is-video="false"
    :background-media="data?.image_logo_ad_section?.background_image"
    :logos="data?.image_logo_ad_section?.logos"
    :is-ufc="route.params.slug === 'ufc'"
    :logo-title="data?.image_logo_ad_section?.logo_title"
  ></CenteredContentLogoSection>
  <InfoImageCenterSection
    :title="data?.image_text_section?.title"
    :subtitle="data?.image_text_section?.subtitle"
    :description="data?.image_text_section?.description"
    :image="data?.image_text_section?.image"
  ></InfoImageCenterSection>
</template>
